<template>
    <div>
        <app-template>

            <div class="max-w-5xl mx-auto px-4 pt-6 pb-20">

                <!-- Header -->
                <div class="mb-8">
                    <h1 class="text-2xl font-semibold text-gray-800">Paramètres du compte</h1>
                    <p class="text-sm text-gray-500">Gérez vos informations personnelles et vos préférences.</p>
                </div>

                <div>

                    <!-- Bloc : Informations personnelles -->
                    <div class="bg-white rounded-xl shadow p-6 mb-6">
                        <h2 class="text-lg font-medium text-gray-700 mb-4">Informations personnelles</h2>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                            <div>
                                <label class="block text-sm font-medium text-gray-600 mb-1">Prénom</label>
                                <input v-model="form.prenom" type="text" placeholder="Votre prénom"
                                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none" />
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-gray-600 mb-1">Nom</label>
                                <input v-model="form.nom" type="text" placeholder="Votre nom"
                                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none" />
                            </div>

                            <div class="md:col-span-2">
                                <label class="block text-sm font-medium text-gray-600 mb-1">Adresse e-mail</label>
                                <input v-model="form.email" type="email" placeholder="votre@email.com"
                                    class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none" />
                            </div>

                        </div>
                    </div>

                    <!-- Bloc : Thème -->
                    <div class="bg-white rounded-xl shadow p-6 mb-6">
                        <h2 class="text-lg font-medium text-gray-700 mb-1">Thème de l'interface</h2>
                        <p class="text-xs text-gray-400 mb-4">Choisissez l'apparence de votre espace de travail.</p>

                        <div class="grid grid-cols-3 gap-4">

                            <!-- Light -->
                            <div @click="form.theme = 'light'"
                                :class="form.theme === 'light' ? 'ring-2 ring-orange-500 border-orange-400' : 'border-gray-200 hover:border-gray-300'"
                                class="cursor-pointer border-2 rounded-xl p-4 transition-all duration-200">
                                <div class="rounded-lg overflow-hidden mb-3 border border-gray-200 flex h-16">
                                    <div class="w-8 bg-gray-200 flex flex-col gap-1.5 p-1.5">
                                        <div class="w-full h-1 rounded bg-gray-400"></div>
                                        <div class="w-full h-1 rounded bg-gray-300"></div>
                                        <div class="w-full h-1 rounded bg-gray-300"></div>
                                    </div>
                                    <div class="flex-1 bg-gray-50 p-2 space-y-1.5">
                                        <div class="h-1.5 bg-gray-200 rounded w-3/4"></div>
                                        <div class="h-1.5 bg-gray-100 rounded w-1/2"></div>
                                    </div>
                                </div>
                                <div class="flex items-center justify-between">
                                    <span class="text-sm font-medium text-gray-700">Clair</span>
                                    <div v-if="form.theme === 'light'" class="w-4 h-4 rounded-full bg-orange-500 flex items-center justify-center">
                                        <i class="fas fa-check text-white" style="font-size: 8px;"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Dark -->
                            <div @click="form.theme = 'dark'"
                                :class="form.theme === 'dark' ? 'ring-2 ring-orange-500 border-orange-400' : 'border-gray-200 hover:border-gray-300'"
                                class="cursor-pointer border-2 rounded-xl p-4 transition-all duration-200">
                                <div class="rounded-lg overflow-hidden mb-3 border border-gray-700 flex h-16">
                                    <div class="w-8 bg-gray-800 flex flex-col gap-1.5 p-1.5">
                                        <div class="w-full h-1 rounded bg-gray-500"></div>
                                        <div class="w-full h-1 rounded bg-gray-700"></div>
                                        <div class="w-full h-1 rounded bg-gray-700"></div>
                                    </div>
                                    <div class="flex-1 bg-gray-50 p-2 space-y-1.5">
                                        <div class="h-1.5 bg-gray-200 rounded w-3/4"></div>
                                        <div class="h-1.5 bg-gray-100 rounded w-1/2"></div>
                                    </div>
                                </div>
                                <div class="flex items-center justify-between">
                                    <span class="text-sm font-medium text-gray-700">Sombre</span>
                                    <div v-if="form.theme === 'dark'" class="w-4 h-4 rounded-full bg-orange-500 flex items-center justify-center">
                                        <i class="fas fa-check text-white" style="font-size: 8px;"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Orange -->
                            <div @click="form.theme = 'orange'"
                                :class="form.theme === 'orange' ? 'ring-2 ring-orange-500 border-orange-400' : 'border-gray-200 hover:border-gray-300'"
                                class="cursor-pointer border-2 rounded-xl p-4 transition-all duration-200">
                                <div class="rounded-lg overflow-hidden mb-3 border border-orange-200 flex h-16">
                                    <div class="w-8 bg-orange-500 flex flex-col gap-1.5 p-1.5">
                                        <div class="w-full h-1 rounded bg-orange-300"></div>
                                        <div class="w-full h-1 rounded bg-orange-400"></div>
                                        <div class="w-full h-1 rounded bg-orange-400"></div>
                                    </div>
                                    <div class="flex-1 bg-gray-50 p-2 space-y-1.5">
                                        <div class="h-1.5 bg-gray-200 rounded w-3/4"></div>
                                        <div class="h-1.5 bg-gray-100 rounded w-1/2"></div>
                                    </div>
                                </div>
                                <div class="flex items-center justify-between">
                                    <span class="text-sm font-medium text-gray-700">Orange</span>
                                    <div v-if="form.theme === 'orange'" class="w-4 h-4 rounded-full bg-orange-500 flex items-center justify-center">
                                        <i class="fas fa-check text-white" style="font-size: 8px;"></i>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Bloc : Déconnexion -->
                    <div class="bg-white rounded-xl shadow p-6 mb-6">
                        <h2 class="text-lg font-medium text-gray-700 mb-1">Session</h2>
                        <p class="text-xs text-gray-400 mb-4">Vous serez redirigé vers la page de connexion.</p>

                        <button @click="logout"
                            class="flex items-center gap-2 px-4 py-2 rounded-lg border border-red-200 text-red-600 text-sm font-medium hover:bg-red-50 transition-all duration-200">
                            <i class="fas fa-sign-out-alt"></i>
                            Se déconnecter
                        </button>
                    </div>

                </div>
            </div>

            <!-- Save button -->
            <div class="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50">
                <button @click="save" :disabled="loading"
                    class="group relative bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white font-medium px-8 py-3.5 rounded-full transition-all duration-300 disabled:opacity-50 shadow-2xl hover:scale-105 flex items-center gap-2">
                    <svg v-if="!loading" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />
                    </svg>
                    <svg v-else class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span class="text-base">{{ loading ? 'Enregistrement en cours...' : 'Enregistrer les modifications' }}</span>
                </button>
            </div>

        </app-template>
    </div>
</template>

<script>
export default {
    name: "ParametreCompte",

    data() {
        return {
            loading: false,

            form: {
                prenom: '',
                nom: '',
                email: '',
                theme: 'light',
            },
        };
    },

    mounted() {
        const account = this.$account.account;
        this.form.prenom = account.prenom;
        this.form.nom    = account.nom;
        this.form.email  = account.email;
        this.form.theme  = account.theme || 'light';
    },

    methods: {

        save() {
            this.loading = true;

            this.$request.post('/account/update', this.form)
                .then(() => {
                    // Refresh page
                    window.location.reload();
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        logout() {
            if (confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
                localStorage.removeItem('auth-token');
                window.location.href = '/login';
            }
        },
    },
};
</script>